// CleverTap/DataLayer constants for Budget Friendly ETFs.
// Values aligned with `CLP_TRADING_MALL_CT.csv` (component id: budget_friendly_ftfs).

export const BUDGET_ETF_COMPONENT_NAME = "stocks_market_card_sku_details";

export const BUDGET_ETF_CLICK_TYPE_TAB =
  "stocks_market_card_sku_details_tab_click";

export const BUDGET_ETF_CLICK_TYPE_CARD =
  "stocks_market_card_sku_details_card_click";

export const BUDGET_ETF_CLICK_TYPE_LINK =
  "stocks_market_card_sku_details_link_click";

export const BUDGET_ETF_CLICK_TYPE_ICON =
  "stocks_market_card_sku_details_icon_click";

export const BUDGET_ETF_PRODUCT_CATEGORY = "investment";

export const BUDGET_ETF_PROPERTY_TYPE = "clp";

export const BUDGET_ETF_PRODUCT_NAME = "budget friendly etfs - trading mall";

export const BUDGET_ETF_JOURNEY_TAG = "Demat";

export const BUDGET_ETF_CAMPAIGN = "DPAOP3| May";

export const BUDGET_ETF_SPRINT = "DPAOP3| May";

export const BUDGET_ETF_REFERENCE_ID = "budget_friendly_ftfs";
